import { render } from "./invoicing.vue?vue&type=template&id=32b381f1"
import script from "./invoicing.vue?vue&type=script&lang=js"
export * from "./invoicing.vue?vue&type=script&lang=js"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__